export const indexGetters = {
    AnalysisTitle: state => state.index.AnalysisTitle,
    
};